export function packGrid(events) {
  const cols = 3

  const grid = []
  const result = []

  function ensureRows(row) {
    while (grid.length <= row) {
      grid.push(new Array(cols).fill(false))
    }
  }

  function canPlace(row, col, width, height) {
    if (col + width > cols) return false

    for (let r = row; r < row + height; r++) {
      ensureRows(r)

      for (let c = col; c < col + width; c++) {
        if (grid[r][c]) {
          return false
        }
      }
    }

    return true
  }

  function occupy(row, col, width, height) {
    for (let r = row; r < row + height; r++) {
      for (let c = col; c < col + width; c++) {
        grid[r][c] = true
      }
    }
  }

  events.forEach((event) => {
    const width = event.featured ? 2 : 1
    const height = event.featured ? 2 : 1

    let placed = false
    let row = 0

    while (!placed) {
      ensureRows(row)

      for (let col = 0; col < cols; col++) {
        if (canPlace(row, col, width, height)) {
          occupy(row, col, width, height)

          result.push({
            row,
            col,
            rowSpan: height,
            colSpan: width
          })

          placed = true
          break
        }
      }

      row++
    }
  })

  return result
}
